import React from "react";
import { Redirect } from "react-router-dom";

/** 발명자(rank 2)는 메뉴에 없는 연차/비용/기한 등 URL 직접 접근 차단 */
function withDenyInventor(WrappedComponent, redirectTo = "/patent/list") {
  function DenyInventorGuard(props) {
    const raw =
      sessionStorage.getItem("auth") ?? sessionStorage.getItem("rank");
    const auth = raw != null && raw !== "" ? Number(raw) : NaN;
    if (
      Number.isFinite(auth) &&
      window.$Global.checkAuth("특허회사_발명자만", auth)
    ) {
      return <Redirect to={redirectTo} />;
    }
    return <WrappedComponent {...props} />;
  }

  const name = WrappedComponent.displayName || WrappedComponent.name || "Component";
  DenyInventorGuard.displayName = `withDenyInventor(${name})`;
  return DenyInventorGuard;
}

export default withDenyInventor;
